import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message, Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {
        key:'$index', 
        label: '序号'
    },
    {
        key:'resourceName', 
        label: '信息资源目录名称', 
        width: 100
    },
    {
        key: 'isEnable',
        label: '审核状态',
        width: 120,
        render: (value) => {
            if(value === 1 || value === 0) {
                return <Tag color="#2db7f5">可使用</Tag>
            } else if(value === 2) {
                return <Tag color="#87d068">待审核</Tag>
            } else if(value === 3) {
                return <Tag color="#f50">审核不通过</Tag>
            }
        }
    },
    {
        key:'themeName', 
        label: '主题名称', 
        width: 100
    },
    { 
        key:'publishEmployeeName', 
        label: '发布人', 
        width: 100

    },
    { 
        key:'phone', 
        label: '申请人电话', 
        width: 100

    },
    { 
        key:'email', 
        label: '申请人邮箱', 
        width: 100

    },
    { 
        key:'publishTime', 
        label: '发布日期', 
        width: 100

    }
    
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('dataCenterAdmin/getResourse?' + params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const queryDetail = (id) => {
    return fetch.get(`develop/student/result/detail/${id}`);
}

const getAttr = (id) => {
    return fetch.get(`dataCenter/getAttr/${id}`);
}

const getDict = (id) => {
    return fetch.get(`dataCenter/getDict/${id}`);
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection =() => {
    return DataGrid.selections;
}

const getStatusById = (id) => {
    return fetch.get(`develop/student/result/status/${id}`)
}

const back = (ids) => {
    return fetch.post(`develop/student/result/status/back`, ids);
}

const update = (id, data) => {
    return fetch.post(`develop/student/result/update/${id}`, data);
}

const approval = (id , data)=> {
    return fetch.post(`dataCenterAdmin/approvalCatalog/${id}`, data);
}

const getOrgTheme = () => {
    return fetch.post(`dataCenter/orgTheme/list`,{})
}

const add = (data) => {
    return fetch.post(`dataCenter/submitResource` , data )
}

const remove = (ids) => {
    return fetch.post(`dataCenterAdmin/deleteResource` , ids)
}

const assignCatalog = (data) => {
    return fetch.post(`dataCenterAdmin/assignCatalog` , data)
}

export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    getStatusById,
    queryDetail,
    back,
    update,
    getAttr,
    getDict,
    approval,
    getOrgTheme,
    add ,
    remove ,
    assignCatalog
}